import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { EngagementClosingDate } from '../models/engagement-closing-date.model';

export const CreateClosingDateDiscussion = createAsyncThunk(
    'closingDate/createDiscussion',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.post(
            `/api/Marketplace/Engagements/${engagementId}/ClosingDate/Discussion`
        );

        if (response.status !== 200) {
            const message =
                response?.response?.data?.title ??
                response?.response?.data?.detail ??
                'An error occurred while creating the closing date discussion.';
            createNotification(message, 'error');
            throw new Error('Failed to create closing date discussion');
        }

        return response.data as EngagementClosingDate;
    }
);
